<template>
  <div class="container-menu" @click="close()">
    <div class="menu-list d-flex align-items-start align-items-sm-center" @click.stop>
      <div class="content">
        <ul>
          <router-link to="/directors">
            <li :class="[isActive ? 'is-active' : '']" @click="close()">
              Directors
            </li>
          </router-link>
          <router-link to="/production-designers">
            <li :class="[isActive ? 'is-active' : '']" @click="close()">
              Production Designers
            </li>
          </router-link>
          <router-link to="/picture-editors">
            <li :class="[isActive ? 'is-active' : '']" @click="close()">
              Picture Editors
            </li>
          </router-link>
          <router-link to="/sound-editors">
            <li :class="[isActive ? 'is-active' : '']" @click="close()">
              Sound Editors
            </li>
          </router-link>
          <br>
          <li :class="[isActive ? 'is-active' : '']" @click="close()">
            <a href="https://dgcontario.wordpress.com" target="_blank">MEET THE MAKERS</a>
          </li>
          <br>
          <li :class="[isActive ? 'is-active' : '']" @click="close()">
            <a href="https://www.instagram.com/ontariodgc" target="_blank">
              <img class="instagram" alt="instagram" src="../assets/instagram.svg">
              <img class="instagram on-hover" alt="instagram" src="../assets/instagram-hover.svg">
            </a>
          </li>
          <br>
          <li :class="`mt-4 ${isActive ? 'is-active' : ''}`">
            <p>To learn more about terms and conditions for engagement of DGC Ontario Members, please <a href="https://www.dgc.ca/en/ontario/agreements/standard-agreement/" target="_blank">click here</a>.</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Person',
  props: {
    isActive: Boolean
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
.container-menu {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 98;
  width: 100vw;
}

.menu-list {
  max-width: 500px;
  background: rgba(0, 0, 0, 0.95);
  height: 100vh;
  display: flex;
  align-items: center;
}

.content {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: white;
  text-align: left;
  padding-left: 2.5em;
  padding-right: 2.5em;
  font-size: 2em;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

li {
  font-family: "Fortescue-semibold";
  letter-spacing: 1.5px;
  font-size: 22px;
  padding-top: 20px;
  text-transform: uppercase;
  text-decoration: none;
}
h1 {
  font-size: 4em;
}
p {
  font-size: 13px;
  text-transform: none;
  // max-width: 500px;
}
a {
  color: white;
  text-decoration: none;
}
a:hover {
  color: #d69a2d;
  text-decoration: none;
}

img.instagram.on-hover,
a:hover img.instagram {
  opacity: 0;
}
a:hover img.instagram.on-hover {
  opacity: 1;
  position: absolute;
  z-index: 2;
}

.instagram {
  width: 40px;
  position: absolute;
  z-index: 1;
}

$total-items: 10;

li.is-active {
  animation: fadeIn 0.6s linear;
  animation-fill-mode: both;
}

// Set delay per List Item
@for $i from 1 through $total-items {
  li:nth-child(#{$i}) {
    animation-delay: 0.05s * $i;
    animation-timing-function: ease-in;
  }
}

// Keyframe animation
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  75% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

@media only screen and (max-width: 600px) {
  .menu-list {
    padding-top: 120px;
  }
  .content {
    font-size: 1em;
  }
}
</style>

